import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FileUploadService } from './../file-upload.service';
import { Globals } from './../globals';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.css']
})
export class GalleryComponent implements OnInit {
  loadingTxt: string;
  loading: boolean;
  loadingOk: number;
  images: string[];
  currentImage: string;
  @ViewChild('fileInput') fileInput;

  constructor(private httpClient: HttpClient, private fileUploadService: FileUploadService, private globals: Globals) { }

  ngOnInit() {
    this.loadingTxt = '';
    this.loading = false;
    this.loadingOk = 0;
    this.images = [];
    this.getImages();
  }

  getImages() {
    this.httpClient.get<string[]>('https://www.saaristonsiirin.com/api/getFiles.php/imagegallery/images')
    .subscribe(imagedata => {
      this.images = imagedata;
    });
  }

  uploadImage() {
    this.loadingTxt = 'Lähetän tiedostoa...';
    this.loading = true;
    this.loadingOk = 0;
    const fileBrowser = this.fileInput.nativeElement;
    if (fileBrowser.files && fileBrowser.files[0]) {
      const formData = new FormData();
      formData.append('image', fileBrowser.files[0]);
      this.fileUploadService.uploadimagallery(formData).subscribe(res => {
        this.loadingOk = res[0];
        this.loadingTxt = res[1];
       this.getImages();
      });
    }
  }

  deleteImage($event, imageFile: string) {
    this.httpClient.get('https://www.saaristonsiirin.com/api/deleteFile.php/imagegallery/images/' + imageFile)
    .subscribe(() => {
      this.getImages();
    });
  }

  previewImage($event, imageFile: string) {
    const modal = document.getElementById('previewModal');
    const modalImg = <HTMLImageElement>document.getElementById('imgPreview');
    modal.style.display = 'block';
    modalImg.src = 'https://www.saaristonsiirin.com/api/uploads/imagegallery/images/' + imageFile;
    this.currentImage = imageFile;
  }

  nextPreview() {
    const modalImg = <HTMLImageElement>document.getElementById('imgPreview');
    const currentIndex = this.images.findIndex(data => data === this.currentImage);

    if (currentIndex === this.images.length - 1) {
      this.currentImage = this.images[0];
    } else {
      this.currentImage = this.images[currentIndex + 1];
    }

    modalImg.src = 'https://www.saaristonsiirin.com/api/uploads/imagegallery/images/' + this.currentImage;
  }

  previousPreview() {
    const modalImg = <HTMLImageElement>document.getElementById('imgPreview');
    const currentIndex = this.images.findIndex(data => data === this.currentImage);

    if (currentIndex === 0) {
      this.currentImage = this.images[this.images.length - 1];
    } else {
      this.currentImage = this.images[currentIndex - 1];
    }

    modalImg.src = 'https://www.saaristonsiirin.com/api/uploads/imagegallery/images/' + this.currentImage;
  }

  closePreview() {
    const modal = document.getElementById('previewModal');
    modal.style.display = 'none';
  }

}



// WEBPACK FOOTER //
// C:/DEV/saaristonsiirin/src/app/gallery/gallery.component.ts